import { Box, Paper, Stack, Typography } from "@mui/material";
import { ReactElement } from "react";

export const StatItem = ({
  stat,
  icon,
  description,
}: {
  stat: string;
  icon: ReactElement;
  description: string;
}) => {
  return (
    <Paper elevation={1} sx={{ p: "24px", height: "100%" }}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            backgroundColor: "#FAE9F0",
            borderRadius: 4,
            width: "68px",
            height: "68px",
            display: "flex",
            flexShrink: 0,
            "& svg": {
              width: "32px",
              height: "32px",
            },
          }}
          alignContent={"center"}
          alignItems={"center"}
          justifyContent="center"
          className="text-pink"
        >
          {icon}
        </Box>
        <Box>
          <Typography
            variant="h4"
            component="h6"
            fontWeight={600}
            className="text-green font-size-5"
          >
            {stat}
          </Typography>
          <Typography variant="body1" component="p">
            {description}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
};
